const useStyles = () => {
    return {
        container: {
            maxWidth: '500px',
            padding: 3,
            display: 'flex',
            flexDirection: 'column',
            gap: 2
        },
        footer: {
            height: '40px',
            width: 'calc(100% - 48px)',
            display:'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            position: 'absolute',
            bottom: '24px',
            left: '24px'
        },
        maxInput: {
            maxWidth: '200px',
        }
    }
}

export { useStyles }
